<script setup lang="ts">
import { FeatherIcon } from "frappe-ui";
import { computed } from "vue";

const props = defineProps<{
  name: string;
  size?: number | string;
}>();

const filtSlice = (x: string[], c: string) =>
  x.filter((x) => x.startsWith(c)).map((x) => x.slice(1));

function extract(name: string) {
  if (typeof name != "string") {
    name = String(name || "");
  }
  const splits = name.match(/(?:^|\.|#)[^\.\#]+/g);
  const base = splits.shift();
  const attrs = filtSlice(splits, "#");
  const classes = filtSlice(splits, ".");
  return { base, attrs, classes };
}

const attributes = computed(() => {
  const { base: iconName, attrs, classes } = extract(props.name);

  if (typeof props.size == "number") {
    classes.push(`size-${props.size ?? 4}`);
  } else if (props.size) {
    classes.push(props.size);
  }

  for (const attr of attrs) {
    classes.push("BIcon--" + attr);
  }

  return {
    name: iconName,
    class: classes,
  };
});
</script>

<template>
  <FeatherIcon class="inline-block" v-bind="attributes" />
</template>

<style>
.BIcon {
  fill: transparent;
  stroke: currentColor;
}
.BIcon--fill {
  fill: currentColor;
  stroke: currentColor;
}
.BIcon--shade {
  fill: currentColor;
  fill-opacity: 0.3;
  stroke: currentColor;
}
.BIcon--thick {
  stroke-width: 3;
}
</style>
